import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
function SettingsTax({ TaxData, EditData2 }) {
  const { businessName, legalRepresentative } = TaxData;

  return (
    <div className="Settings__Box">
      <h2>Datos Fiscales</h2>
      <FontAwesomeIcon
        icon={faPen}
        color="#9ea0a5"
        className="EditSettingsButton"
        size="2.4rem"
        onClick={EditData2}
      />
      <div className="settingsTax">
        <table style={{ width: "100%" }}>
          <tr>
            <th>Razon Fiscal</th>
            <td>{businessName}</td>
          </tr>
          <tr>
            <th>Representante Legal</th>
            <td>{legalRepresentative}</td>
          </tr>
        </table>
      </div>
    </div>
  );
}

export default SettingsTax;
